// extracted by mini-css-extract-plugin
export default {"fade":"Modal_fade__Fs3FQ","modal":"Modal_modal__ZjBx1"};